import { transformSearch } from "@/api/helper.ts";
import { queryClient } from "@/query-client.ts";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";
import courtTypeStationService from "../services/court-type-station-service";

export const courtTypeStationSearchSchema = z.object({
	search: z.string().optional(),
	include: z.string().optional(),
	page: z.number().nullable().optional(),
	per_page: z.number().optional(),
	courtType: z.string().optional(),
	province: z.string().optional(),
	court_type_id: z.string().nullable().optional(),
	province_code: z.string().nullable().optional(),
});

export const courtTypeStationsQueryOptions = (
	search?: z.infer<typeof courtTypeStationSearchSchema>,
	options?: { enabled: boolean },
) => {
	return queryOptions({
		queryKey: ["court_type_station", search],
		queryFn: () =>
			courtTypeStationService.list(
				transformSearch(search, [
					"search",
					"courtType",
					"court_type_id",
					"province_code",
				]),
			),
		...options,
	});
};

export const courtTypeStationQueryOptions = (courtTypeStationId: string) => {
	return queryOptions({
		queryKey: ["court_type_station", courtTypeStationId],
		queryFn: () => courtTypeStationService.findById(courtTypeStationId),
	});
};

export const useCourtTypeStationCreateMutation = (
	courtTypeStationId?: string,
) => {
	return useMutation({
		mutationKey: ["court_type_station", courtTypeStationId],
		mutationFn: courtTypeStationService.create,
		meta: {
			successMessage: "Court type station created successfully",
		},
		onSuccess: () =>
			queryClient.invalidateQueries({ queryKey: ["court_type_station"] }),
	});
};

export const useCourtTypeStationMutation = (courtTypeStationId?: string) => {
	return useMutation({
		mutationKey: ["court_type_station", courtTypeStationId],
		mutationFn: courtTypeStationService.upsert,
		meta: {
			successMessage: "Court type station updated successfully",
		},
		onSuccess: () =>
			queryClient.invalidateQueries({ queryKey: ["court_type_station"] }),
	});
};
